import { useEffect, useState } from 'react';
import { getToken } from '../../api/http';

/* Uživo stanje "zabave" (efekti koje admin pali kod operatera): jedna Server-Sent Events veza za celu aplikaciju
   (/API/podesavanja/zabava/tok). Pri povezivanju server odmah šalje trenutno stanje, a posle svake izmene koju admin
   sačuva — novo. EventSource se sam ponovo povezuje (retry 3 s). Komponente se pretplaćuju preko useZabava(). */

let stanje = { aktivno: false };
let izvor = null;
let token = null;
const pretplatnici = new Set();

const objavi = (s) => { stanje = s; pretplatnici.forEach((f) => f(s)); };

const poveži = () => {
    const t = getToken();
    if (izvor && t === token) return;
    if (izvor) { izvor.close(); izvor = null; }
    token = t;
    if (!t) { objavi({ aktivno: false }); return; }
    izvor = new EventSource(`/API/podesavanja/zabava/tok?t=${encodeURIComponent(t)}`);
    izvor.addEventListener('zabava', (e) => { try { objavi(JSON.parse(e.data)); } catch { /* neispravna poruka */ } });
};

/** trenutni efekti za prijavljenog korisnika ({ aktivno: false } kad nema ničega) */
export function useZabava() {
    const [s, setS] = useState(stanje);
    useEffect(() => {
        pretplatnici.add(setS);
        poveži();
        setS(stanje);
        /* odjava/prijava: novi token -> nova veza */
        const sync = () => poveži();
        window.addEventListener('tacho-auth', sync);
        return () => {
            pretplatnici.delete(setS);
            window.removeEventListener('tacho-auth', sync);
            if (!pretplatnici.size && izvor) { izvor.close(); izvor = null; token = null; }
        };
    }, []);
    return s;
}

/** uloga iz tokena (samo za prikaz u interfejsu — server sam proverava ulogu na svakom zahtevu) */
export function ulogaIzTokena() {
    try {
        const t = getToken();
        if (!t) return null;
        const p = JSON.parse(atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return p.role || null;
    } catch { return null; }
}
